import 'url-search-params-polyfill';

import React, { Component } from 'react';
import { w3cwebsocket as W3CWebSocket } from 'websocket';

import { Helmet } from 'react-helmet';
import * as jwtDecode from 'jwt-decode';
import IdleTimer from 'react-idle-timer';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { capitalize } from 'lodash';
import { isFeatureEnabled } from './config/featureFlags';

// Local Deps
import AuthRoute from './components/Auth/AuthRoute';
import { logout } from './utils/authUtils';
// import { logoutServices } from './graphql/serviceAuthentication';
import './scss/index.scss';
import history from './config/history';
import { getOrgByID, getMessageCount } from './graphql';
import { getUserByEmail, agreeToPolicy } from './components/Billsby/graphql';
import { initializeBillsby } from './components/Billsby/billsbyInitializer';
// import { UserForApproveUser } from './graphql/users';

// Navigation
import {
  homeRoute,
  aboutRoute,
  contactRoute,
  supportRoute,
  iconfaqsRoute,
  helpRoute,
  codeDefinitionsRoute,
  relNotesRoute,
  resourcesRoute,
  newslettersRoute,
  loginRoute,
  loginFailureRoute,
  registrationRoute,
  invitationRoute,
  registrationGuideRoute,
  salesOpportunitiesRoute,
  toolingRecordsRoute,
  supplierDatabaseRoute,
  growBusinessRoute,
  gettingStartedRoute,
  solicitationsSearchRoute,
  solicitationsShowRoute,
  toolingLocationListRoute,
  // toolingLocationRoute,
  // procurementHistoryRoute,
  supplierCapabilitiesRoute,
  universalDetailsRoute,
  messageCenterRoute,
  contractCenterRoute,
  contractRfqRoute,
  contractQuoteRoute,
  viewQuoteRoute,
  DibbsRFQWizardRoute,
  toolingManagementRoute,
  inventoryManagementRoute,
  accountAdminRoute,
  // bidMatchingRoute,
  // addUserRoute,
  // editUserRoute,
  superAdminHomeRoute,
  // superAdminEditOrgRoute,
  pdmiCredentialsRoute,
  subscriptionPlansRoute,

  // downloadToolingRoute,
  // editInventoryManagementRoute,
  // orgToolingRoute,
  // addProductRoute,
  // editToolingRoute,
  // editToolingManagementRoute,
  termsOfUseRoute,
  privacyPolicyRoute,
  section508Route,
} from './config/navigation/routes';

// Pages

// Static Pages
import Home from './pages/static/Home';
import About from './pages/static/About';
import Contact from './pages/static/Contact';
import iconfaqs from './pages/static/iconfaqs';
import help from './pages/static/help';
import Support from './pages/static/Support';
import CodeDefinitions from './pages/static/CodeDefinitions';
import Resources from './pages/static/Resources/Resources';
import relnotes from './pages/static/relnotes';
import newsletters from './pages/static/newsletters';
import SalesOpportunities from './pages/static/SalesOpportunities/SalesOpportunities';
import ToolingRecords from './pages/static/ToolingRecords/ToolingRecords';
import SupplierDatabase from './pages/static/SupplierDatabase/SupplierDatabase';
import GrowBusiness from './pages/static/GrowBusiness/GrowBusiness';
import IntermediateLogin from './pages/static/IntermediateLogin';
import Registration from './pages/Registration';
import TermsOfUse from './pages/static/TermsOfUse/TermsOfUse';
import RegistrationGuidePage from './pages/RegistrationGuide/RegistrationGuidePage';
import PrivacyPolicy from './pages/static/PrivacyPolicy/PrivacyPolicy';
import Section508 from './pages/static/Section508/Section508';

import SolicitationsSearch from './pages/SolicitationsSearch';
import SolicitationDetail from './pages/SolicitationDetail';
import ToolingLocations from './pages/ToolingLocations';
// import ToolingLocations2 from './pages/ProcurementHistory';
import SupplierCapabilities from './pages/SupplierCapabilities';
import UniversalDetails from './pages/universalDetails';

import MessageCenter from './pages/messageCenter';

import ContractCenter from './pages/ContractCenter';
import ContractRFQ from './pages/contractRFQ';
import ContractQuote from './pages/contractQuote';
import ViewQuote from './pages/ViewQuote';
import DibbsRFQWizard from './pages/DibbsRfq';

import ToolingManagement from './pages/ToolingManagement';
import InventoryManagement from './pages/InventoryManagement';

import AccountAdmin from './pages/AccountAdmin';
// import Notifications from './pages/Notifications'; // This is for bidmatching settings

import SuperAdminHome from './pages/SuperAdminHome';
// import EditOrganization from './components/Modals/EditOrganization';

// import AddUser from './pages/AddUser';
// import EditUser from './pages/EditUser';
// import ToolingMgmt from './pages/ToolingMgmt';
// import AddProduct from './pages/AddProduct/AddProduct';

// import DownloadTooling from './pages/DownloadTooling/DownloadTooling';

// import EditInventoryManagement from './pages/EditInventoryManagement';

// import EditProduct from './pages/EditProduct';
// import EditToolingManagement from './components/Modals/EditToolingManagement';
import PdmiCredentials from './pages/PdmiCredentials';
import SubscriptionPlan from './components/Billsby/SubscriptionPlan';

// Components
import TopNav from './components/TopNav';
import IconFooter from './components/IconFooter/IconFooter';
// import ToolingLocationsDetail from './components/ToolingLocationsDetail';
import NFButton from './components/primitives/NFButton';
import SubscriptionInfo from './components/Billsby/SubscriptionInfo';
import Subscription from './components/Subscription/Subscription';
import Invitation from './pages/Invitation/Invitation';
import updateInvitedSupplier from './components/Invitation/updateInvitedSupplier';
import GettingStarted from './pages/static/GettingStarted/GettingStarted';

export default class Root extends Component {
  static initialState = {
    auth: {
      jwtToken: null,
      expiration: 0,
      role: null,
      id: null,
      organizationId: null,
      permissions: null,
      cageCode: null,
      email: null,
    },
    originalOrgId: null,
    orgInfo: null,
    newMessage: false,
    newMessageCount: 0,
    client: null,
    updateConversation: false,
    updateConversationList: false,
    canSeeMessageCenter: false,
    loginFailureAlertMessage: [
      {
        alertType: 'warning',
        alertMessage:
          'There was an error logging in. Support has been notified',
      },
    ],
    forceLogout: false,
    // udHistory: null,
    subscriptionLevel: '',
    billsbyCustomerId: '',
    industryAssociations: [],
    organizationId: null,
    previousPlan: '',
  };

  static _getDecodedAuthData(jwtToken) {
    const decoded = jwtDecode(jwtToken);
    console.log('decoded', decoded);
    const id = decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/id`];
    return {
      jwtToken,
      expiration: decoded.exp,
      role: decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/role`],
      id,
      organizationId: decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/orgId`],
      permissions:
        decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/permissions`],
      name: decoded.name,
      email: decoded.email,
      cageCode: decoded[`${process.env.REACT_APP_AUTH0_NAMESPACE}/cageCode`],
    };
  }

  constructor() {
    super();
    this._isMounted = false;
    this.state = Root.initialState;
    const jwtToken = this._getCookie('idToken');
    if (jwtToken) {
      this.state.auth = Root._getDecodedAuthData(jwtToken);
    }

    if (performance.navigation.type !== 1) {
      if (document.cookie.indexOf('idToken=') !== -1) {
        const pathname = window.location.pathname;
        // Explicitly allow privacy policy and terms of use pages - skip logout check entirely
        const isPrivacyPolicy = pathname.includes('/privacy-policy');
        const isTermsOfUse = pathname.includes('/terms-of-use');

        // Skip logout check for policy pages - don't check other paths, don't call logout
        if (!isPrivacyPolicy && !isTermsOfUse) {
          if (
            !pathname.includes('/superadmin') &&
            !pathname.includes('/support/solicitations') &&
            !pathname.includes('/help') &&
            !pathname.includes('/support/codedefinitions') &&
            !pathname.includes('/iconfaq') &&
            !pathname.includes('/support/relnotes') &&
            !pathname.includes('/solicitations') &&
            !pathname.includes('/tools/locator') &&
            !pathname.includes('/history/search') &&
            !pathname.includes('/about') &&
            !pathname.includes('/contact') &&
            !pathname.includes('/rfq') &&
            !pathname.includes('/cfolders') &&
            !pathname.includes('/login') &&
            !pathname.includes('/messagecenter') &&
            !pathname.includes('/details') &&
            !pathname.includes('/suppliers') &&
            !pathname.includes('/contractcenter') &&
            !pathname.includes('/memberadmin/inventorymanagement/') &&
            !pathname.includes('/memberadmin/toolingmanagement/') &&
            !pathname.includes('/billsby') &&
            !pathname.includes('/static/SupportResources') &&
            !pathname.includes('/static/ToolingRecords') &&
            !pathname.includes('/static/SupplierDatabase') &&
            !pathname.includes('/static/SalesOpportunities') &&
            !pathname.includes('/static/GrowBusiness') &&
            !pathname.includes('/support/newsletters') &&
            !pathname.includes('/static/Section508')
          ) {
            logout();
          }
        }
      }
    }
  }

  async componentDidMount() {
    console.log('componentDidMount');
    this._isMounted = true;

    // Initialize Billsby configuration
    if (isFeatureEnabled('ENABLE_BILLSBY')) {
      try {
        initializeBillsby().catch(error => {
          console.warn(
            'Billsby initialization failed - this is expected in development:',
            error,
          );
        });
      } catch (error) {
        console.warn(
          'Failed to initialize Billsby config - this is expected in development:',
          error,
        );
      }
    }

    const jwtToken = this._getCookie('idToken');
    if (jwtToken) {
      console.log('componentDidMount plus jwt');
      const auth = await this._updateStateWithAuth(jwtToken);

      await this._getUserOrgInfo(auth);
      this.setupWebsocket(jwtToken, auth);
      if (isFeatureEnabled('ENABLE_BILLSBY')) {
        const userInformation = await getUserByEmail(auth.email);
        if (userInformation && userInformation.getUserByEmailOrganization) {
          const subscriptionLevel = capitalize(
            userInformation.getUserByEmailOrganization.subscriptionLevel,
          );
          const billsbyCustomerId =
            userInformation.getUserByEmailOrganization.billsbyCustomerId;
          const industryAssociations =
            userInformation.getUserByEmailOrganization.industryAssociations;
          const organizationId =
            userInformation.getUserByEmailOrganization.organizationId;
          const previousPlan =
            userInformation.getUserByEmailOrganization.previousPlan;
          // Note: Policy agreement is now handled by PolicyAgreementModal before login completes
          // The banner is kept as a fallback for edge cases, but should not normally be shown

          this.setState({
            subscriptionLevel: subscriptionLevel || '',
            billsbyCustomerId: billsbyCustomerId || '',
            industryAssociations: industryAssociations || [],
            organizationId: organizationId || '',
            previousPlan: previousPlan || '',
            // Modal handles policy agreement before login
          });
        }
      }
    }
  }

  componentWillUnmount() {
    // fixes memory leak
    this._isMounted = false;
    if (this.state && this.state.client) {
      this.state.client.close();
    }
  }

  setupWebsocket = (jwtToken, auth) => {
    // Close existing connection if it exists
    if (this.state.client) {
      try {
        this.state.client.close();
      } catch (error) {
        console.error('Error closing existing websocket:', error);
      }
    }

    console.log(process.env.REACT_APP_WEBSOCKET);

    try {
      const client = new W3CWebSocket(
        `${process.env.REACT_APP_WEBSOCKET}?jwtToken=${jwtToken}`,
      );

      this.setState({ client });

      // Set timeout to prevent hanging on connection issues
      const connectionTimeout = setTimeout(() => {
        console.log('Websocket connection timeout');
        // Don't block the UI if websocket fails to connect
        if (client.readyState !== WebSocket.OPEN) {
          console.error('Websocket connection timed out');
        }
      }, 5000);

      client.onopen = () => {
        console.log('WebSocket Client Connected');
        clearTimeout(connectionTimeout);
      };

      client.onerror = error => {
        console.log('Websocket error:', error);
        clearTimeout(connectionTimeout);
      };

      client.onmessage = async message => {
        try {
          console.log('client.onmessage fired');
          console.log('message.data', message.data);
          const data = JSON.parse(message.data);
          console.log(data);
          if (data.forceLogout) {
            console.log('forced logout here');
            this.setState({ forceLogout: true });
            setTimeout(logout, 3000);
          } else {
            const urlParams = new URLSearchParams(window.location.search);
            const myParam = urlParams.get('message');

            if (
              window.location.pathname.includes('/messagecenter') &&
              data.convoId === myParam
            ) {
              this.setState({ updateConversation: true });
            } else if (
              window.location.pathname.includes('/messagecenter') &&
              !myParam
            ) {
              this.setState({ updateConversationList: true });
            } else if (auth && auth.id) {
              // Only update message count if auth.id exists
              try {
                const res = await getMessageCount(auth.id);
                this.setState({
                  newMessage: true,
                  newMessageCount: res.newMsgCount,
                });
              } catch (error) {
                console.error('Error getting message count:', error);
              }
            }
          }
        } catch (error) {
          console.error('Error handling websocket message:', error);
        }
      };
    } catch (error) {
      console.error('Error setting up websocket:', error);
    }
  };

  _setMessageNotification = async () => {
    // console.log("getMessageCount2", this.state.auth.id)

    const res = await getMessageCount(this.state.auth.id);
    this.setState({
      newMessage: res.newMsgCount > 0,
      newMessageCount: res.newMsgCount,
    });
  };

  _getUserOrgInfo = async auth => {
    if (auth && auth.id) {
      try {
        const org = await getOrgByID(auth.organizationId);
        if (org.inviteDate && !org.claimDate) {
          await updateInvitedSupplier(auth.organizationId);
        }
        this.setState({
          orgInfo: org,
        });
      } catch (err) {
        console.error(err);
      }
    }
    if (auth && auth.permissions && auth.permissions.includes(1)) {
      this.setState({ canSeeMessageCenter: true });
      try {
        const res = await getMessageCount(auth.id);
        if (res.newMsgCount > 0) {
          this.setState({
            newMessage: true,
            newMessageCount: res.newMsgCount,
          });
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  _getCookie = cname => {
    const name = `${cname}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  };

  _updateStateWithAuth = async jwtToken => {
    const auth = await Root._getDecodedAuthData(jwtToken);
    this.setState(
      {
        auth,
      },
      // ,
      //   console.log("update", this.state.auth)
    );
    return auth;
  };

  _login = async jwtToken => {
    console.log('_login');
    if (!jwtToken) {
      return;
    }

    try {
      const auth = await Root._getDecodedAuthData(jwtToken);

      // Complete login - policy check will happen on homepage
      this._completeLogin(jwtToken, auth);
    } catch (error) {
      console.error('Critical login error:', error);
      history.push(loginFailureRoute);
    }
  };

  _completeLogin = (jwtToken, auth) => {
    // Set auth state immediately
    this.setState({ auth }, () => {
      console.log('Auth state updated successfully');

      // After auth state is set, THEN redirect to home
      // This prevents any race conditions with redirects
      history.push('/');

      // Now perform all the non-critical operations AFTER redirect
      // These run in the background and won't block the UI
      setTimeout(() => {
        this._performPostLoginOperations(jwtToken, auth);
      }, 100);
    });
  };

  _performPostLoginOperations = async (jwtToken, auth) => {
    try {
      // Get user organization info
      await this._getUserOrgInfo(auth);

      // Setup websocket after a delay to avoid freezing during initial rendering
      setTimeout(() => {
        try {
          this.setupWebsocket(jwtToken, auth);
        } catch (wsError) {
          console.error('Websocket setup error:', wsError);
        }
      }, 1000);

      if (isFeatureEnabled('ENABLE_BILLSBY')) {
        // Get subscription info
        try {
          const userInformation = await getUserByEmail(auth.email);
          if (userInformation && userInformation.getUserByEmailOrganization) {
            const subscriptionLevel = capitalize(
              userInformation.getUserByEmailOrganization.subscriptionLevel,
            );
            const billsbyCustomerId =
              userInformation.getUserByEmailOrganization.billsbyCustomerId;
            const industryAssociations =
              userInformation.getUserByEmailOrganization.industryAssociations;
            const organizationId =
              userInformation.getUserByEmailOrganization.organizationId;
            const previousPlan =
              userInformation.getUserByEmailOrganization.previousPlan;
            // Note: Policy agreement is now handled by PolicyAgreementModal before login completes
            // The banner is kept as a fallback for edge cases, but should not normally be shown

            if (this._isMounted) {
              this.setState({
                subscriptionLevel: subscriptionLevel || '',
                billsbyCustomerId: billsbyCustomerId || '',
                industryAssociations: industryAssociations || [],
                organizationId: organizationId || '',
                previousPlan: previousPlan || '',
                // Modal handles policy agreement before login
              });
            }
          }
        } catch (userInfoError) {
          console.error('Error getting user information:', userInfoError);
        }
      }
    } catch (error) {
      console.error('Non-critical post-login error:', error);
    }
  };

  _onIdle = () => {
    logout();
  };

  _resetUpdateConversation = () => {
    this.setState({ updateConversation: false, updateConversationList: false });
  };

  _handleAgreeToPolicy = async () => {
    try {
      if (!this.state.auth || !this.state.auth.id) {
        console.error('Cannot agree to policy: user not authenticated');
        return;
      }

      await agreeToPolicy(this.state.auth.id);

      // Policy agreement is now handled by modal before login
    } catch (error) {
      console.error('Error agreeing to policy:', error);
      // Optionally show an error message to the user
    }
  };

  _handleDoNotAgreeToPolicy = () => {
    // Log out the user
    logout();
  };

  render() {
    // console.log("orgInfo", this.state.orgInfo)
    const {
      auth,
      originalOrgId,
      orgInfo,
      newMessage,
      newMessageCount,
      updateConversation,
      updateConversationList,
      canSeeMessageCenter,
      loginFailureAlertMessage,
      forceLogout,
      subscriptionLevel,
      billsbyCustomerId,
      industryAssociations,
      organizationId,
      previousPlan,
    } = this.state;

    return (
      <SubscriptionInfo
        auth={auth}
        mySubscriptionLevel={subscriptionLevel}
        myBillsbyCustomerId={billsbyCustomerId}
        myIndustryAssociations={industryAssociations}
        myOrganizationId={organizationId}
        myPreviousPlan={previousPlan}
      >
        <div id="site-container">
          <Helmet>
            <meta charSet="utf-8" />
            <title>NFFS ICON - Home Page</title>
            <meta
              name="description"
              content="The Integrated Casting Order Networks (ICON) provides the DLA and manufacturers with innovative procurement solutions for defense related metal castings."
            />
            <meta
              name="keywords"
              content="machine tooling,casting tooling,foundry pattern,military castings,amc icon,foundry tooling,icon portal"
            />
          </Helmet>

          <Router history={history}>
            <React.Fragment>
              <Switch>
                {/* <!-- HOME PAGE --> */}
                <Route
                  exact
                  path={homeRoute}
                  render={props => (
                    <Home
                      login={this._login}
                      logout={logout}
                      auth={auth}
                      originalOrgId={originalOrgId}
                      orgInfo={orgInfo}
                      newMessage={newMessage}
                      newMessageCount={newMessageCount}
                      canSeeMessageCenter={canSeeMessageCenter}
                      subscriptionLevel={subscriptionLevel}
                      organizationId={organizationId}
                      {...props}
                    />
                  )}
                />
                <Route
                  exact
                  path={loginFailureRoute}
                  render={props => (
                    <Home
                      login={this._login}
                      logout={logout}
                      auth={auth}
                      originalOrgId={originalOrgId}
                      orgInfo={orgInfo}
                      newMessage={newMessage}
                      newMessageCount={newMessageCount}
                      canSeeMessageCenter={canSeeMessageCenter}
                      alertMessages={loginFailureAlertMessage}
                      {...props}
                    />
                  )}
                />
                <Route
                  render={() => (
                    <div>
                      {/* <!-- TOP NAV BAR --> */}
                      <TopNav
                        login={this._login}
                        logout={logout}
                        auth={auth}
                        originalOrgId={originalOrgId}
                        orgInfo={orgInfo}
                        newMessage={newMessage}
                        newMessageCount={newMessageCount}
                        canSeeMessageCenter={canSeeMessageCenter}
                        subscriptionLevel={subscriptionLevel}
                        className="nf-top-nav--dark"
                        isHomePage={false}
                      />
                      <div id="content-wrap">
                        <Switch>
                          {/* <!-- STATIC ROUTES --> */}
                          <Route
                            exact
                            path={homeRoute}
                            render={props => (
                              <Home
                                {...props}
                                auth={auth}
                                login={this._login}
                                isHomePage
                              />
                            )}
                          />
                          <Route
                            exact
                            path={supportRoute}
                            component={Support}
                          />
                          <Route exact path={aboutRoute} component={About} />
                          <Route
                            exact
                            path={contactRoute}
                            component={Contact}
                          />
                          <Route
                            exact
                            path={termsOfUseRoute}
                            component={TermsOfUse}
                          />
                          <Route
                            exact
                            path={privacyPolicyRoute}
                            component={PrivacyPolicy}
                          />
                          <Route
                            exact
                            path={iconfaqsRoute}
                            component={iconfaqs}
                          />
                          <Route exact path={helpRoute} component={help} />
                          <Route
                            exact
                            path={codeDefinitionsRoute}
                            component={CodeDefinitions}
                          />
                          <Route
                            exact
                            path={relNotesRoute}
                            component={relnotes}
                          />
                          <Route
                            exact
                            path={resourcesRoute}
                            component={Resources}
                          />
                          <Route
                            exact
                            path={newslettersRoute}
                            component={newsletters}
                          />
                          <Route
                            exact
                            path={section508Route}
                            component={Section508}
                          />

                          {/* <!-- LOGIN PAGE --> */}
                          <Route
                            path={loginRoute}
                            render={() => (
                              <IntermediateLogin
                                login={this._login}
                                auth={auth}
                                history={history}
                              />
                            )}
                          />
                          {/* <!-- REGISTRATION PAGE --> */}
                          <Route
                            exact
                            auth={auth}
                            path={registrationRoute}
                            render={() => <Registration auth={auth} />}
                          />
                          <Route
                            exact
                            auth={auth}
                            path={invitationRoute}
                            render={() => <Invitation />}
                          />
                          {/* <!-- REGISTRATION GUIDE PAGE --> */}
                          <Route
                            exact
                            path={registrationGuideRoute}
                            render={() => <RegistrationGuidePage />}
                          />
                          {/* <!-- SOLICITATIONS PAGES --> */}
                          <AuthRoute
                            auth={auth}
                            exact
                            path={solicitationsSearchRoute}
                            render={() => <SolicitationsSearch auth={auth} subscriptionLevel={subscriptionLevel} />}
                          />
                          <AuthRoute
                            auth={auth}
                            exact
                            path={solicitationsShowRoute}
                            render={props => (
                              <SolicitationDetail
                                solicitationId={
                                  props.match.params.solicitationId
                                }
                                auth={auth}
                                subscriptionLevel={subscriptionLevel}
                              />
                            )}
                          />
                          {/* <!-- TOOLING LOCATIONS PAGE --> */}
                          <Route
                            exact
                            path={toolingLocationListRoute}
                            render={() => (
                              <ToolingLocations
                                auth={auth}
                                // setUniversalDetailsHistory={this._setUniversalDetailsHistory}
                              />
                            )}
                          />
                          <Route
                            auth={auth}
                            exact
                            path={supplierCapabilitiesRoute}
                            render={props => (
                              <SupplierCapabilities auth={auth} {...props} />
                            )}
                          />

                          {/* Feature Routes */}
                          {isFeatureEnabled('ENABLE_SALES_OPPORTUNITIES') && (
                            <Route
                              exact
                              path={salesOpportunitiesRoute}
                              render={props => (
                                <SalesOpportunities
                                  login={this._login}
                                  logout={logout}
                                  auth={auth}
                                  originalOrgId={originalOrgId}
                                  orgInfo={orgInfo}
                                  newMessage={newMessage}
                                  newMessageCount={newMessageCount}
                                  canSeeMessageCenter={canSeeMessageCenter}
                                  {...props}
                                />
                              )}
                            />
                          )}

                          <Route
                            exact
                            path={toolingRecordsRoute}
                            render={props => (
                              <ToolingRecords
                                login={this._login}
                                logout={logout}
                                auth={auth}
                                originalOrgId={originalOrgId}
                                orgInfo={orgInfo}
                                newMessage={newMessage}
                                newMessageCount={newMessageCount}
                                canSeeMessageCenter={canSeeMessageCenter}
                                {...props}
                              />
                            )}
                          />

                          <Route
                            exact
                            path={gettingStartedRoute}
                            render={props => (
                              <GettingStarted
                                login={this._login}
                                logout={logout}
                                auth={auth}
                                originalOrgId={originalOrgId}
                                orgInfo={orgInfo}
                                newMessage={newMessage}
                                newMessageCount={newMessageCount}
                                canSeeMessageCenter={canSeeMessageCenter}
                                {...props}
                              />
                            )}
                          />

                          {isFeatureEnabled('ENABLE_SUPPLIER_DATABASE') && (
                            <Route
                              exact
                              path={supplierDatabaseRoute}
                              render={props => (
                                <SupplierDatabase
                                  login={this._login}
                                  logout={logout}
                                  auth={auth}
                                  originalOrgId={originalOrgId}
                                  orgInfo={orgInfo}
                                  newMessage={newMessage}
                                  newMessageCount={newMessageCount}
                                  canSeeMessageCenter={canSeeMessageCenter}
                                  {...props}
                                />
                              )}
                            />
                          )}

                          {isFeatureEnabled('ENABLE_GROW_BUSINESS') && (
                            <Route
                              exact
                              path={growBusinessRoute}
                              render={props => (
                                <GrowBusiness
                                  login={this._login}
                                  logout={logout}
                                  auth={auth}
                                  originalOrgId={originalOrgId}
                                  orgInfo={orgInfo}
                                  newMessage={newMessage}
                                  newMessageCount={newMessageCount}
                                  canSeeMessageCenter={canSeeMessageCenter}
                                  {...props}
                                />
                              )}
                            />
                          )}

                          {/* <!-- UNIVERSAL DETAILS PAGE --> */}
                          <AuthRoute
                            auth={auth}
                            exact
                            path={universalDetailsRoute}
                            render={() => (
                              <UniversalDetails
                                auth={auth}
                                // udHistory={this.state.udHistory}
                              />
                            )}
                          />

                          <AuthRoute
                            auth={auth}
                            exact
                            path={messageCenterRoute}
                            roles={[
                              'GOVERNMENT_USER',
                              'COMMON_USER',
                              'COMMON_ADMIN',
                            ]}
                            render={() => (
                              <MessageCenter
                                auth={auth}
                                resetUpdateConversation={
                                  this._resetUpdateConversation
                                }
                                setMessageNotification={
                                  this._setMessageNotification
                                }
                                updateConversation={updateConversation}
                                updateConversationList={updateConversationList}
                              />
                            )}
                          />

                          {/* CONTRACT CENTER PAGES */}
                          <AuthRoute
                            auth={auth}
                            exact
                            path={contractCenterRoute}
                            // roles={['SUPER_ADMIN']}
                            roles={[
                              'GOVERNMENT_USER',
                              'COMMON_USER',
                              'COMMON_ADMIN',
                            ]}
                            render={() => (
                              <Subscription service="RFQ Management" level="ICON Plus">
                                <ContractCenter auth={auth} />
                              </Subscription>
                            )}
                          />

                          <AuthRoute
                            auth={auth}
                            exact
                            path={contractRfqRoute}
                            roles={[
                              'GOVERNMENT_USER',
                              'COMMON_USER',
                              'COMMON_ADMIN',
                            ]}
                            // roles={['COMMON_USER', 'COMMON_ADMIN']}
                            render={() => (
                              <Subscription service="RFQ Management" level="ICON Plus">
                                <ContractRFQ auth={auth} />
                              </Subscription>
                            )}
                          />

                          <AuthRoute
                            auth={auth}
                            exact
                            path={viewQuoteRoute}
                            roles={[
                              'GOVERNMENT_USER',
                              'COMMON_USER',
                              'COMMON_ADMIN',
                            ]}
                            // roles={['COMMON_USER', 'COMMON_ADMIN']}
                            render={props => (
                              <Subscription service="RFQ Management" level="ICON Plus">
                                <ViewQuote auth={auth} {...props} />
                              </Subscription>
                            )}
                          />

                          <AuthRoute
                            auth={auth}
                            exact
                            path={contractQuoteRoute}
                            roles={[
                              'GOVERNMENT_USER',
                              'COMMON_USER',
                              'COMMON_ADMIN',
                            ]}
                            // roles={['COMMON_USER', 'COMMON_ADMIN']}
                            render={() => (
                              <Subscription service="RFQ Management" level="ICON Plus">
                                <ContractQuote auth={auth} />
                              </Subscription>
                            )}
                          />

                          <AuthRoute
                            auth={auth}
                            exact
                            path={DibbsRFQWizardRoute}
                            roles={['SUPER_ADMIN']}
                            // roles={['COMMON_USER', 'COMMON_ADMIN']}
                            render={props => (
                              <DibbsRFQWizard auth={auth} {...props} />
                            )}
                          />
                          {/* <!-- TOOLING & INVENTORY MANAGEMENT PAGES --> */}
                          <AuthRoute
                            auth={auth}
                            // @TODO define these roles correctly
                            roles={['COMMON_USER', 'COMMON_ADMIN']}
                            exact
                            path={toolingManagementRoute}
                            render={() => <ToolingManagement auth={auth} />}
                          />

                          <AuthRoute
                            auth={auth}
                            // @TODO define these roles correctly
                            roles={['COMMON_USER', 'COMMON_ADMIN']}
                            exact
                            path={inventoryManagementRoute}
                            render={() => <InventoryManagement auth={auth} />}
                          />

                          {/* <!-- ACCOUNT ADMIN PAGES --> */}
                          <AuthRoute
                            auth={auth}
                            // @TODO define these roles correctly
                            roles={['COMMON_ADMIN']}
                            exact
                            path={accountAdminRoute}
                            render={() => <AccountAdmin auth={auth} />}
                          />

                          {/* SUPER ADMIN PAGES */}
                          <AuthRoute
                            auth={auth}
                            roles={['SUPER_ADMIN']}
                            exact
                            path={superAdminHomeRoute}
                            render={() => <SuperAdminHome auth={auth} />}
                          />

                          {/* <!-- PDMI CREDENTIALS PAGE --> */}
                          <AuthRoute
                            auth={auth}
                            exact
                            path={pdmiCredentialsRoute}
                            render={props => <PdmiCredentials {...props} />}
                          />
                          {isFeatureEnabled('ENABLE_BILLSBY') && (
                            <Route
                              path={subscriptionPlansRoute}
                              component={SubscriptionPlan}
                            />
                          )}
                          <Redirect to={homeRoute} />
                        </Switch>
                      </div>
                      {auth && (
                        <IdleTimer
                          ref={ref => {
                            this.idleTimer = ref;
                          }}
                          element={document}
                          onActive={this.onActive}
                          onIdle={this._onIdle}
                          onAction={this.onAction}
                          debounce={250}
                          timeout={1000 * 60 * 30}
                        />
                      )}
                    </div>
                  )}
                />
              </Switch>
              <Modal isOpen={forceLogout} toggle={logout}>
                <ModalHeader>Your permissions have changed</ModalHeader>
                <ModalBody>
                  A site or organiation administrator has changed your
                  permissions. Please logout and login again so the changes can
                  take affect.
                </ModalBody>
                <ModalFooter>
                  <NFButton
                    className="nf-button nf-button--form nf-button--orange"
                    onClick={logout}
                  >
                    Logout
                  </NFButton>
                </ModalFooter>
              </Modal>
              <IconFooter />
            </React.Fragment>
          </Router>
        </div>
      </SubscriptionInfo>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Root.jsx